import CertificateIcon from '@/assets/images/certificate.svg';
import DownloadIcon from '@/assets/images/download.svg';
import MobileIcon from '@/assets/images/mobile.svg';
import PlayIcon from '@/assets/images/play.svg';
import { DMImage } from '@/components/custom-image/custom-image';
import { convertSecondsToMinOrHours, countStats } from '@/lib/utils';
import { useCourseStore } from '@/lib/zustand/store/store';

function CourseFeatures() {
  const { playList, setData } = useCourseStore(state => state);
  const data = countStats(playList);
  return (
    <>
      <div className='flex justify-between items-center mb-3 mt-5'>
        <h4>This courses includes</h4>
      </div>
      <div className='columns-1 md:columns-2 lg:columns-1'>
        <p className='text-sm font-normal text-white leading-6 mt-1 flex gap-2'>
          <DMImage src={PlayIcon} width={14} height={14} alt='Play Icon' />
          {convertSecondsToMinOrHours(data?.totalDuration)} of on demand video
        </p>
        <p className='text-sm font-normal text-white leading-6 mt-1 flex gap-2'>
          <DMImage src={DownloadIcon} width={14} height={14} alt='Play Icon' />
          {data.totalTasks} Downloadable resources
        </p>
        <p className='text-sm font-normal text-white leading-6 mt-1 flex gap-2'>
          <DMImage src={MobileIcon} width={14} height={14} alt='Play Icon' />
          Access on mobile
        </p>
        <p className='text-sm font-normal text-white leading-6 mt-1 flex gap-2'>
          <DMImage src={CertificateIcon} width={14} height={14} alt='Play Icon' />
          Certificate of completion
        </p>
      </div>
    </>
  );
}

export default CourseFeatures;
